import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { json } from "react-router-dom";


const user = localStorage.getItem("mashawiriuser")

const initialState = {
    loading: false,
    mashawiriAuthinticate : localStorage.getItem("mashawiriAuthinticate") || false,
    mashawiritoken: localStorage.getItem("mashawiritoken"),
    mashawiriuser: JSON.parse(user) ,
    error: ""
}


    export const login = createAsyncThunk("login/loginUser", (data) => {
        return axios.post(`${process.env.REACT_APP_API_URL}company_login`, data)
        .then(res => {
            console.log(res);
            return res.data
        })
    }) 


    export const logout = createAsyncThunk("logout/logoutUser", (_, {getState}) => {
        const token = getState().auth.mashawiritoken
        return axios.post(`${process.env.REACT_APP_API_URL}logout`, {},
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => {return res.data})
    })

    const authReducer = createSlice({
    name: "auth",
    initialState,
    extraReducers: builder => {
        builder.addCase(login.pending, (state) => {
            state.loading = true
            state.mashawiriAuthinticate = false
            state.error = ""
            state.mashawiritoken = null
            state.mashawiriuser = null
        })
        builder.addCase(login.fulfilled, (state, action) => {
            if(action.payload.status){
                state.loading = false
                state.mashawiriAuthinticate = true
                state.mashawiritoken = action.payload.token
                state.error = ""
                state.mashawiriuser = action.payload.client
                localStorage.setItem('mashawiriAuthinticate', true);
                localStorage.setItem('mashawiritoken', action.payload.token);
                localStorage.setItem("mashawiriuser", JSON.stringify(action.payload.client))
            }
            else{
                state.loading = false
                state.error = action.payload.message
                state.isAuth = false
                state.token = null
                state.rule = null
                state.mashawiriuser = null
            }
        })
        builder.addCase(login.rejected, (state, action) => {
            state.loading = false
            state.error = "Login Faild"
            state.mashawiriAuthinticate = false
            state.mashawiritoken = null
            state.mashawiriuser = null
        })





        // logout 
        builder.addCase(logout.pending, (state) => {
            state.loading = true
            state.error = ""
        })
        builder.addCase(logout.fulfilled,(state) => {
            state.loading = false
            state.error = ""
            state.mashawiriAuthinticate = false
            state.mashawiritoken = null
            state.mashawiriuser = null
            localStorage.removeItem("mashawiriAuthinticate");
            localStorage.removeItem("mashawiritoken");
            localStorage.removeItem("mashawiriuser");

        } )
        builder.addCase(logout.rejected, (state) => {
            state.loading = false
            state.error = "Logout Faild"
            state.isAuth = true
        })
    }
})

export default authReducer.reducer